export const dounuts =[
    {
        "name":"FASHIONABILITY",
        "key":"fashionability",
    },
    {
        "name":"COLOR",
        "key":"color",
    },
    {
        "name":"FIT",
        "key":"fit",
    },
    {
        "name":"FABRIC",
        "key":"fabric",
    },
    {
        "name":"SIZE",
        "key":"size",
    },
]